module.exports = __webpack_public_path__ + "img/cardinal.01ea5d64.png";